import React, { useEffect, useState } from 'react';

/**
 * Reading progress "merit meter" — the blog's signature element.
 *
 * Grounded in the subject: Pakistani admissions run on merit percentages
 * and cutoffs, so reading progress is shown as a filling percentage bar
 * pinned under the navbar. It is the one memorable thing on the article
 * page; everything else stays quiet.
 */
const ReadingProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const scrollTop = doc.scrollTop || document.body.scrollTop;
      const scrollHeight = doc.scrollHeight - doc.clientHeight;
      setProgress(scrollHeight > 0 ? Math.round((scrollTop / scrollHeight) * 100) : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <div
      className="fixed top-16 left-0 right-0 z-40 h-1 bg-slate-200/70 pointer-events-none"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={progress}
      aria-label="Reading progress"
    >
      <div
        className="h-full bg-gradient-to-r from-primary-600 to-[#1E256F] motion-reduce:transition-none transition-[width] duration-150 ease-out"
        style={{ width: `${progress}%` }}
      />
      {progress >= 5 && progress < 100 && (
        <span className="absolute right-2 -top-0.5 -translate-y-full text-[10px] font-bold text-[#1E256F] bg-white border border-slate-200 rounded-md px-1.5 py-0.5 shadow-sm select-none">
          {progress}% read
        </span>
      )}
      {progress >= 100 && (
        <span className="absolute right-2 -top-0.5 -translate-y-full text-[10px] font-bold text-emerald-700 bg-white border border-emerald-200 rounded-md px-1.5 py-0.5 shadow-sm select-none">
          Finished ✓
        </span>
      )}
    </div>
  );
};

export default ReadingProgressBar;
